import React from "react";
import UploadSection from "../../components/upload_content/upload_section";
import {BackGround} from "../../components/background/background";
import DragAndDrop from "../../components/drag_and_drop/drag_and_drop";
import {uploading} from "../../core/state/detection/detection_actions";
import {useDetectionState} from "../../core/state/detection/detection_context";
import {useHistory} from "react-router-dom/cjs/react-router-dom";
import {DETECT_PAGE} from "../../config/router/router";


export const HomePage = () => {

    const {dispatch} = useDetectionState()
    const history = useHistory();

    const handleDrop = (files) => {
        console.log(files)
        const src = URL.createObjectURL(files[0]);
        history.push(DETECT_PAGE)
        dispatch(uploading(files[0], src))

    }

    return (
        <BackGround>
            <DragAndDrop handleFileDrop={handleDrop}>
                <UploadSection/>
            </DragAndDrop>
        </BackGround>
    );
}
